import { Avatar, Box, Button, Grid, MenuItem, Typography, useTheme } from "@mui/material";
import { IStoreState, useAppDispatch, useAppSelector } from "../../redux";
import React from "react";
import { fetchWorkflowListAsync, IWorkflowGET, upsertWorkflow } from "../../redux/automation";
import { useNavigate } from "react-router-dom";
import { StandardTableActions } from "../../Components/StandardTableActions/StandardTableActions";
import { IDataTableProps, MobileLogoRenderType, RenderType } from "../../Components/Table/interfaces/IDataTableProps";
import { CustomLink } from "../../Components/Customlink/CustomLink";
import { StatusRenderer } from "../../Components/ActiveInActiveStatus/ActiveInActiveStatus";
import { LoadState } from "../../constants/enum";
import { useDateFilter } from "../../Components/Table/hooks/useDateFilter";
import PageContainer from "../../Components/PageContainer/PageContainer";
import { PageTitleBar } from "../../Components/PageTitleBar/PageTitleBar";
import { DataTable } from "../../Components/Table/DataTable";
import { ConfirmDialog } from "../../Components/Dialogs/ConfirmDialog";

export const Automation: React.FC = () => {
  const { list, totalRecords, loading } = useAppSelector(
    (storeState: IStoreState) => storeState.automation
  );
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { date, type, handleDateSelectChange, dateDropdownList, setDate } = useDateFilter({ defaultType: "allTimes" });

  const [pagination, setPagination] = React.useState({
    pageNumber: 1,
    rowsPerPage: 10,
  });
  const [dateFilter, setDateFilter] = React.useState<string>("ALL");

  const [openConfirm, setOpenConfirm] = React.useState<IWorkflowGET | null>(
    null
  );


  const redirectToUpsetDocument = (documentCode?: string) => {
    if (documentCode) {
      navigate(`/g4sign/documents/manage/${documentCode}`);
    } else {
      navigate(`/g4sign/documents/manage`);
    }
  };


  const fetchList = () => {
    dispatch(
      fetchWorkflowListAsync({
        page: pagination.pageNumber,
        rowsPerPage: pagination.rowsPerPage,
      })
    );
  };

  React.useEffect(() => {
    fetchList();
  }, [pagination]);


  const dataTableProps: IDataTableProps = {
    isPagination: true,
    totalRecords: totalRecords,
    rowsPerPageOptions: pagination.rowsPerPage,
    isDataLoading: loading !== LoadState.succeeded,
    mobileLogo: {
      type: MobileLogoRenderType.reactNode,
      onMobileLogoRender: (data: any) => {
        return (
          <Avatar
            sx={{
              width: 45,
              height: 45,
              color: "#fff",
              ml: "-8px",
              mr: 2,
            }}
          ></Avatar>
        );
      },
    },

    columns: [
      {
        key: "view",
        headerName: "Actions",
        headingAlign: "center",
        fieldName: "",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IWorkflowGET) => {
          return (
            <StandardTableActions
              onEditClick={() => {
                navigate(
                  `/settings/automation/manage-automation/${row.workflow_basic_code}`
                );
              }}
            onDeleteClick={
              row.status === "ACTIVE"
                ? () => {
                    setOpenConfirm(row);
                  }
                : undefined
            }
            onRestoreClick={
              row.status === "INACTIVE"
                ? () => {
                    setOpenConfirm(row);
                  }
                : undefined
            }
            />
          );
        },
      },

      {
        key: "workflow_basic_code",
        headerName: "Workflow Code",
        fieldName: "workflow_basic_code",
        enableSorting: true,
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IWorkflowGET) => {
          return (
            <CustomLink
              to={`/settings/automation/manage-automation/${row.workflow_basic_code}`}
              label={row.workflow_basic_code}
            />
          );
        },
      },
      {
        key: "workflow_name",
        headerName: "Workflow Name",
        fieldName: "workflow_name",
        enableSorting: true,
        renderType: RenderType.CUSTOM_RENDER,
      },
      {
        key: "run_as",
        headerName: "Run As",
        fieldName: "run_as",
        enableSorting: true,
        renderType: RenderType.CUSTOM_RENDER,
      },
      // {
      //   key: "table_name",
      //   headerName: "Module Name",
      //   fieldName: "module_name",
      //   enableSorting: true,
      //   renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
      //   onRowCellValueRender: (value, row) => {
      //     return formatText(value);
      //   },
      // },

      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        enableSorting: true,
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row) => {
          return <StatusRenderer status={row.status} />;
        },
      },

      {
        key: "insert_ts",
        headerName: "Date Created",
        fieldName: "insert_ts",
        enableSorting: true,
        renderType: RenderType.DATE_TIME,
      },
    ],

    items: list,

    onPageChange: (newPageNumber: number) => {
      setPagination({ ...pagination, pageNumber: newPageNumber });
    },
    onRowsPerPageChange: (pageNumber: number, rowsPerPage: number) => {
      setPagination({
        pageNumber: pageNumber,
        rowsPerPage: rowsPerPage,
      });
    },
  };


  const handleConfirm = () => {
    if (openConfirm) {
      const toggledStatus =
        openConfirm.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";

      dispatch(
        upsertWorkflow({
          payload: { ...(openConfirm as any), status: toggledStatus },
          onCallback(isSuccess, code) {
            if (isSuccess) {
              setOpenConfirm(null);
              fetchList();
            }
          }})
      );
    }
  };

  const isLightMode = useTheme().palette.mode === "light";

  return (
    <>
      <PageContainer title="Automation" description="this is innerpage">
        {/* <StandadCard>
        <Grid container spacing={2.5}>
          <Grid item xs={12}>

   
          </Grid>
          <Grid item xs={12} md={3}>
            <SignatureStatusWidget count={5} status="Pending" />
          </Grid>
          <Grid item xs={12} md={3}>
            <SignatureStatusWidget count={5} status="Completed" />
          </Grid>
          <Grid item xs={12} md={3}>
            <SignatureStatusWidget count={20} status="Draft" />
          </Grid>
          <Grid item xs={12} md={3}>
            <SignatureStatusWidget
              count={11}
              status="Pending"
              hideRightBorder
            />
          </Grid>
        </Grid>
      </StandadCard> */}
        {/* <Box mt={5}>
        <FileUploadV2
          value={null}
          onChange={(data) => setFile(file)}
          onDelete={() => setFile(null)}
          actionButton={{
            text: "Get Signed",
            onClick: ()=> setOpen(true)
          }}
        />
      </Box> */}

        <Box mt={5}>
          <PageTitleBar
            heading="Workflows"
            rightHeading={
              <Button
              sx={{
                display: "flex",
                marginLeft: "auto",
                marginY: 2,
                minWidth: "80px !important",
                backgroundColor: isLightMode
                  ? "var(--secondary-color)"
                  : "var(--primary-color)",
                color: isLightMode
                  ? "var(--text-light-color)"
                  : "var(--text-dark-color)",
                border: isLightMode
                  ? "var(--border-light-color) 1px solid"
                  : "var(--border-dark-color) 1px solid",
                "&:hover": {
                  backgroundColor: isLightMode
                    ? "var(--secondary-color)"
                    : "var(--tertiary-color)",
                  opacity: isLightMode ? 0.85 : 1,
                  // color: isLightMode ? "var(--primary-color)" : "var(--secondary-color)",
                  border: isLightMode
                    ? "var(--border-light-color) 1px solid"
                    : "var(--border-dark-color) 1px solid",
                },
              }}
                variant="contained"
                onClick={() => {
                  navigate("/settings/automation/manage-automation");
                }}
              >
                Create
              </Button>
            }
          />
          <DataTable {...dataTableProps} />
        </Box>
      </PageContainer>
      {openConfirm && (
        <ConfirmDialog
          open={true}
          content={
            <Typography variant="h4">
              {openConfirm.status === "ACTIVE"
                ? "Are you sure you want to delete this item? By confirming, the associated workflow will be moved to the inactive stage."
                : "Are you sure you want to Restore this item? By confirming, the associated workflow will be moved to the active stage."}
            </Typography>
          }
          onClose={() => setOpenConfirm(null)}
          onConfrim={handleConfirm}
        />
      )}
    </>
  );
};
